export enum SortTypes {
  Date = "date",
  ReadTime = "read time",
}
